// extracted by mini-css-extract-plugin
module.exports = {"container":"ADengiBanner_container__G_tzB","logo":"ADengiBanner_logo__2nxNu","bannerImage":"ADengiBanner_bannerImage__2Aj7r","advertising":"ADengiBanner_advertising__3KPif"};